'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_DocumentTemplatesListResponseItem(id, name, kind, createdBy, createdAt) {
  this.Bk = null;
  this.Kq = null;
  this.Xi = null;
  this.Xh = null;
  this.Xg = null;
  this.Bk = id;
  this.Kq = name;
  this.Xi = kind;
  this.Xh = createdBy;
  this.Xg = createdAt;
}
export { $c_Lapp_api_DocumentTemplatesListResponseItem as $c_Lapp_api_DocumentTemplatesListResponseItem };
$p = $c_Lapp_api_DocumentTemplatesListResponseItem.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_DocumentTemplatesListResponseItem;
/** @constructor */
function $h_Lapp_api_DocumentTemplatesListResponseItem() {
}
export { $h_Lapp_api_DocumentTemplatesListResponseItem as $h_Lapp_api_DocumentTemplatesListResponseItem };
$h_Lapp_api_DocumentTemplatesListResponseItem.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_DocumentTemplatesListResponseItem)) {
    var x = this.Bk;
    var x$2 = x$0.Bk;
    if ((((x === null) ? (x$2 === null) : x.f(x$2)) && (this.Kq === x$0.Kq))) {
      var x$3 = this.Xi;
      var x$4 = x$0.Xi;
      var $x_2 = (x$3 === x$4);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.Xh;
      var x$6 = x$0.Xh;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.Xg;
      var x$8 = x$0.Xg;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 5;
});
$p.t = (function() {
  return "DocumentTemplatesListResponseItem";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.Bk;
      break;
    }
    case 1: {
      return this.Kq;
      break;
    }
    case 2: {
      return this.Xi;
      break;
    }
    case 3: {
      return this.Xh;
      break;
    }
    case 4: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDateTime(this.Xg);
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "id";
      break;
    }
    case 1: {
      return "name";
      break;
    }
    case 2: {
      return "kind";
      break;
    }
    case 3: {
      return "createdBy";
      break;
    }
    case 4: {
      return "createdAt";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_api_DocumentTemplatesListResponseItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.il)));
}
export { $isArrayOf_Lapp_api_DocumentTemplatesListResponseItem as $isArrayOf_Lapp_api_DocumentTemplatesListResponseItem };
var $d_Lapp_api_DocumentTemplatesListResponseItem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_DocumentTemplatesListResponseItem, "app.api.DocumentTemplatesListResponseItem", ({
  il: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_DocumentTemplatesListResponseItem as $d_Lapp_api_DocumentTemplatesListResponseItem };
//# sourceMappingURL=app.api.-Document-Templates-List-Response-Item.js.map
